import axios from 'axios';

const instance = axios.create();

// instance.defaults.headers.common['SOMETHING'] = 'something'

instance.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

export default instance;
